import { client } from '../apiConfig'

const getFileUrl = (uuid) => {
  return client.get(`file/read/${uuid}/geturl`)
}

export { getFileUrl }
